// import React, { useState } from "react";
import { Helmet } from "react-helmet";
import "./Pricing.css";
import { Link } from "react-router-dom";
import { HeartPulse, Search, TrendingUp } from "lucide-react";
import Cat from "./assets/cat.png";
import Bird from "./assets/bird.png";
import Carousel from "./Carousel";
import Wix from "./assets/wix-logo.png";
import WordPress from "./assets/wordpress-logo.png";
import Squarespace from "./assets/squarespace-logo.png";
import Hostinger from "./assets/hostinger-logo.png";

const Pricing = () => {
  return (
    <div className="page-wrapper">
      <Helmet>
        <meta name="description" content="Affordable SEO Packages" />
        <title>Affordable SEO Packages | Attoli</title>
        <link rel="canonical" href="https://attoli.com/pricing" />
      </Helmet>

      <div className="pricing-container">
        <div className="pricing-header">
          <h1 className="pricing-main-title">
            <span className="pricing-accent"> Affordable SEO Packages </span>
            for Finance Businesses
          </h1>
          <div className="pricing-intro-wrapper">
            <img
              src={Cat}
              alt="Cartoon character of a cat ready to pounce with a purple background"
              className="pricing-image pricing-image-left"
            />

            <p className="pricing-intro">
              Only a few financial institutions are currently working with us
              right now, and every SEO trial request will be screened to ensure
              we’re the right match for your company’s goals and type of
              business.
            </p>

            <img
              src={Bird}
              alt="Cartoon character of a bird twitting about SEO with a purple background"
              className="pricing-image pricing-image-right"
            />
          </div>
          <p className="pricing-carousel-text">
            Website builders we are familiar with
          </p>
          <div className="pricing-carousel">
            <Carousel
              logos={[
                { src: Wix, alt: "Wix logo" },
                { src: WordPress, alt: "WordPress logo" },
                { src: Squarespace, alt: "Squarespace logo" },
                { src: Hostinger, alt: "Hostinger logo" },
              ]}
            />
          </div>
        </div>

        <div className="pricing-grid">
          <div className="pricing-card">
            <div className="pricing-card-header">
              <span className="price">$150</span>
              <div className="pricing-icon-container blue-bg">
                <HeartPulse size={48} className="pricing-icon" />
              </div>
            </div>
            <h3 className="pricing-title">Health Check</h3>
            <p className="pricing-description">Basic Site Audit</p>
            <ul className="pricing-features">
              <li>2 months of site monitoring</li>
              <li>Identify critical issues</li>
              <li>Top searched keywords for the month</li>
              <li>Identify their closest competitors</li>
              <li>Suggestions / next actions</li>
            </ul>
            <a
              href="https://buy.stripe.com/4gMdR8fQLc225Sg2ooeME00"
              className="pricing-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              Get Started
            </a>
          </div>
          <div className="pricing-card">
            <div className="pricing-card-header">
              <div>
                <span className="disc-price">$600</span>
                <span className="pricing-discount-badge">20% OFF</span>
                <span className="price-trial">$480</span>
              </div>
              <div className="pricing-icon-container blue-bg">
                <Search size={48} className="pricing-icon" />
              </div>
            </div>
            <p className="pricing-lable">Most Popular</p>
            <h3 className="pricing-title">Trial Package</h3>
            <p className="pricing-description">
              One-time assessment and additional content
            </p>
            <ul className="pricing-features">
              <li>2 months of site monitoring</li>
              <li>Identify critical issues</li>
              <li>Top searched keywords for the month</li>
              <li>Identify their closest competitors</li>
              <li>Suggestions / next actions</li>
              <li>2-3 content / blog posts</li>
              <li>1 finance related custom asset tool</li>
            </ul>
            <Link to="/trial" className="pricing-btn pricing-link-btn">
              Request Trial
            </Link>
          </div>
          <div className="pricing-card">
            <div className="pricing-card-header">
              <span className="price-custom">CUSTOM</span>
              <div className="pricing-icon-container blue-bg">
                <TrendingUp size={48} className="pricing-icon" />
              </div>
            </div>
            <h3 className="pricing-title">Long-Term SEO Partnership</h3>
            <p className="pricing-description">
              Month to month affordable SEO for finance related businesses
            </p>
            <ul className="pricing-features">
              <li>Site Health Check Reports</li>
              <li>Keyword Research</li>
              <li>Related Content Creation</li>
              <li>Backlink Gathering</li>
              <li>Site Improvements</li>
              <li>Custom Linkable Assets</li>
              <li>Google Business Profile Maintenance</li>
            </ul>
            <Link to="/services" className="pricing-btn pricing-link-btn">
              Services
            </Link>
          </div>
        </div>
      </div>
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-header">
            <h3 className="footer-logo">attoli</h3>
            <p className="footer-quote">
              "Fool me once, strike one. Fool me twice... strike three." -
              Michael Scott
            </p>
            <p className="footer-description">
              Attoli is an Ottawa-based SEO company helping finance businesses
              across Canada create visibility, connect with customers, and grow
              online with proven digital marketing and SEO engine optimization
              strategies.
            </p>
          </div>

          <div className="footer-links">
            <Link to="/privacy-policy" className="footer-link">
              Privacy & Policy
            </Link>
            <Link to="/contact" className="footer-link">
              Contact
            </Link>

            <a
              href="https://calendly.com/attoli/30min"
              target="_blank"
              className="footer-link"
              rel="noreferrer"
            >
              Book a Meeting
            </a>
          </div>

          <div className="footer-copyright">
            © 2025 Attoli. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Pricing;
